const DefaultEditorModeManager = require('./default');

function displayConfirmationModal (onSave, onDiscard) {
  if (localStorage.getItem('modalAdminStickerConfirmDontShowAgain') === 'true') {
    onSave();
    return;
  }

  const onClose = () => {
    const dontShowAgain = document.querySelector('input#dont-show-again').checked;
    localStorage.setItem('modalAdminStickerConfirmDontShowAgain', dontShowAgain);

    modal.close();
  };

  const modal = INKIVE.Modal.modalWindow(
    INKIVE.TemplatesHelper('modal_restricted_template_confirm'),
    {
      width: 550,
      height: 250,
      headerIcon: 'icon-cloud-download',
      headerTitle: INKIVE.TranslateHelper.translate('modal.admin_sticker.save_changes'),
      buttons: [
        {
          title: INKIVE.TranslateHelper.translate('modal.admin_sticker.save'),
          cls: 'modal-apply-secondary-template',
          onClick: () => {
            onClose();
            onSave();
          }
        },
        {
          title: INKIVE.TranslateHelper.translate('modal.admin_sticker.discard'),
          cls: 'modal-apply-secondary-template',
          onClick: () => {
            onClose();
            onDiscard();
          }
        }
      ]
    }
  );
}

function TemplateEditorModeManager () {
  this.type = 'template';

  this.showList = ['#mode-panel'];

  this.hideList = [
    'header > .tool-size'
  ];

  this.disableList = [
    '#header #shr-buttons > a:not(.save)',
    '.tool-menu a[role="tab"][href="#tabLayouts"]',
    '.tool-content #tabAdmin input[name="search"]',
    '.tool-content #tabAdmin .btn-new-item',
    '.tool-content #tabAdmin a[data-toggle="accordion"][href="#accordionAdminBackgrounds"]',
    '.tool-content #tabAdmin a[data-toggle="accordion"][href="#accordionAdminStickers"]'
  ];
}

TemplateEditorModeManager.prototype = new DefaultEditorModeManager();

TemplateEditorModeManager.prototype.enableUI = function () {
  DefaultEditorModeManager.prototype.enableUI.call(this);

  const EditorModeManager = require('../editor-mode-manager');
  const tool = this.tool;
  const $modePanel = $('#mode-panel');

  $('#canvas-panel').addClass('mode');
  $modePanel.find('a').on('click', function () {
    INKIVE.Modal.togglePageLoader(true);

    const afterSave = () => {
      EditorModeManager.setMode('default');
      INKIVE.Modal.togglePageLoader(false);
    };
    const onSave = () => tool.save(null, afterSave);
    displayConfirmationModal(onSave, afterSave);
  });
};

TemplateEditorModeManager.prototype.disableUI = function () {
  DefaultEditorModeManager.prototype.disableUI.call(this);

  $('#canvas-panel').removeClass('mode');
  $('#mode-panel').find('a').off('click');
};

TemplateEditorModeManager.prototype.afterUIEnable = function (data) {
  this.editor.canvas.runExtensions('enableRuler', {});
  this.editor.loadSvgString(
    Base64.decode(INKIVE.C.BLANK_SVG),
    _.bind(this.onBlankSVG, this, data),
    data.format_width, data.format_height
  );
};

TemplateEditorModeManager.prototype.onBlankSVG = function (data) {
  if (data.content) {
    const attr = {
      background: Base64.decode(data.background),
      defs: Base64.decode(data.defs),
      content: Base64.decode(data.content)
    };

    this.editor.addElement('layout', attr);

    data.old_format_width && data.old_format_height && INKIVE.Helpers.converterLayoutSizeChange(
      data.format_width,
      data.format_height,
      data.old_format_width,
      data.old_format_height
    );
  }
};

module.exports = TemplateEditorModeManager;
